import { apiRoutes } from '@/constants/api-routes';
import { apiRequest } from './http';
import type { ImportSummary, SubscriberView, SubscribersPage } from '@/types/api';

export interface ListSubscribersParams {
  page?: number;
  pageSize?: number;
  q?: string;
  status?: string;
  listId?: string;
}

export interface CreateSubscriberPayload {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  listId?: string | null;
}

export interface UpdateSubscriberPayload {
  firstName?: string;
  lastName?: string;
  phone?: string;
}

export interface ImportRow {
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
}

export interface ImportSubscribersPayload {
  rows: ImportRow[];
  listId?: string | null;
  overwriteList?: boolean;
}

export const adminSubscribersService = {
  async list(params: ListSubscribersParams = {}): Promise<SubscribersPage> {
    return apiRequest<SubscribersPage>(apiRoutes.adminSubscribers.list, {
      method: 'GET',
      query: { ...params },
    });
  },

  async create(payload: CreateSubscriberPayload): Promise<SubscriberView> {
    return apiRequest<SubscriberView>(apiRoutes.adminSubscribers.create, {
      method: 'POST',
      body: payload,
    });
  },

  async update(id: string, payload: UpdateSubscriberPayload): Promise<SubscriberView> {
    return apiRequest<SubscriberView>(apiRoutes.adminSubscribers.one(id), {
      method: 'PATCH',
      body: payload,
    });
  },

  async assignList(id: string, listId: string | null): Promise<SubscriberView> {
    return apiRequest<SubscriberView>(apiRoutes.adminSubscribers.assignList(id), {
      method: 'PATCH',
      body: { listId },
    });
  },

  async reactivate(id: string): Promise<SubscriberView> {
    return apiRequest<SubscriberView>(apiRoutes.adminSubscribers.reactivate(id), {
      method: 'PATCH',
    });
  },

  async remove(id: string): Promise<void> {
    await apiRequest<void>(apiRoutes.adminSubscribers.one(id), { method: 'DELETE' });
  },

  async import(payload: ImportSubscribersPayload): Promise<ImportSummary> {
    return apiRequest<ImportSummary>(apiRoutes.adminSubscribers.import, {
      method: 'POST',
      body: payload,
    });
  },

  async bulkDelete(ids: string[]): Promise<{ deleted: number }> {
    return apiRequest<{ deleted: number }>(apiRoutes.adminSubscribers.bulkDelete, {
      method: 'POST',
      body: { ids },
    });
  },
};
